import { useState, useEffect } from 'react'
import { Container, Grid, TextField, Button, Typography, createTheme, Box, Link } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import CircularProgress from '@mui/material/CircularProgress';
import SelectLevel from '../SelectLevel'
import ViewExamsList from './ViewExamsList'
import { useFetch } from '../../hooks/useFetch'
import AddExamAuthById from './AddExamAuthById'
function ExaminationAuthList({ studentId, sessionId, setAddExam, venueId, handleComplete }) {


    const [catId, setCatId] = useState(1)
    const [examId, setExamId] = useState("")
    const [addAuth, setAddAuth] = useState()

    return (
        <>

            {!addAuth && (
                <Container maxWidth="lg" >

                    <Box mb={5} />



                    <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }} sx={{ border: 'solid', borderWidth: '3px', borderColor: "primary.main", borderRadius: 2 }}>


                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"

                            >
                                <Typography variant="h3" component="h3" color="primary.main" sx={{ textAlign: 'center' }}>
                                    Select Examination
                                </Typography>



                            </Box>


                        </Grid>



                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"

                            >
                                <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'left' }}>
                                    <b>Please note:</b>

                                    <ul>

                                        <li>
                                            Only one examination paper combination per Cambridge course code can be added to your cart.
                                        </li>
                                        <li>
                                            Examination paper combinations with varying qualifications can be added to your cart.
                                        </li>
                                        <li>
                                            Students who wish to select Carry Over or Carry Forward examination combinations are required to verify their eligibility to enter for these examination combinations. Failure to do so within the specified time may results in the entire entry being cancelled.
                                        </li>
                                        <li>
                                            It is the responsibility of the candidate or the candidate’s parent/guardian to select the correct examination paper combination based on the candidates academic requirements.
                                        </li>
                                    </ul>
                                </Typography>



                            </Box>


                        </Grid>
                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"

                            >


                                <Grid item xs={4}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"

                                    >
                                        <SelectLevel catId={catId} setCatId={setCatId} />


                                    </Box>


                                </Grid>

                            </Box>


                        </Grid>
                        <Grid item xs={12} minWidth={1}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"

                            >
                                <ViewExamsList studentId={studentId} sessionId={sessionId} setExamId={setExamId} setAddAuth={setAddAuth} catId={catId} />



                            </Box>


                        </Grid>
                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >

                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <Button fullWidth color={"primary"} variant="contained" onClick={(e) => handleComplete()}>View Cart</Button>


                                    </Box>


                                </Grid>
                            </Box>

                            <Box mb={5} />
                        </Grid>






                    </Grid>
                </Container>


            )}

            {addAuth === 1 && (

                <AddExamAuthById examId={examId} studentId={studentId} sessionId={sessionId} venueId={venueId} setAddAuth={setAddAuth} handleComplete={handleComplete} />


            )}






        </>

    )
}

export default ExaminationAuthList